module.exports = __webpack_public_path__ + "img/8022656.svg";